import { c as _c } from "react/compiler-runtime";
import React, { FC, PropsWithChildren } from 'react';
import classNames from 'classnames';
import Icon from '@/src/app/components/Icon/Icon';
import { IconName } from '@/src/app/components/Icon/types';
export interface ChipProps extends PropsWithChildren {
  icon?: string;
  onClose?: CallableFunction;
  disabled?: boolean;
}
const Chip: FC<ChipProps> = t0 => {
  const $ = _c(19);
  const {
    children,
    icon: t1,
    onClose,
    disabled
  } = t0;
  const icon = t1 === undefined ? "check" : t1;
  const t2 = onClose ? "pr-2" : "pr-4";
  const t3 = disabled ? "bg-gray-400 text-gray-700 pointer-events-none cursor-not-allowed" : null;
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = classNames("inline-flex pl-3 py-0.5 items-center border border-gray-200 bg-black text-sm font-medium text-white whitespace-nowrap", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const t5 = icon as IconName;
  let t6;
  if ($[3] !== disabled) {
    t6 = classNames("text-primary text-xl!", {
      "text-yellow-400": disabled
    });
    $[3] = disabled;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== t5 || $[6] !== t6) {
    t7 = <Icon name={t5} className={t6} />;
    $[5] = t5;
    $[6] = t6;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] !== children) {
    t8 = <span className="ml-2">{children}</span>;
    $[8] = children;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== children || $[11] !== disabled || $[12] !== onClose) {
    t9 = onClose ? <button type="button" className="ml-2 inline-flex flex-shrink-0 rounded-full px-1 text-gray-400 hover:bg-gray-700 hover:text-gray-500" onClick={() => onClose()} disabled={disabled} data-testid="chip-close"><span className="sr-only">Remove filter for {children}</span><Icon name={IconName.CLOSE} className="text-white text-xl!" /></button> : null;
    $[10] = children;
    $[11] = disabled;
    $[12] = onClose;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== t4 || $[15] !== t7 || $[16] !== t8 || $[17] !== t9) {
    t10 = <span className={t4} data-testid="chip-filter">{t7}{t8}{t9}</span>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default Chip;